import React, { useState } from 'react';

interface ChangeRolePopupProps {
  currentRole: string;
  onClose: () => void;
  onRequestConfirmation: (newRole: string) => void;
}

const roles = ['Admin', 'Designer', 'Marketer', 'Viewer'];

const ChangeRolePopup: React.FC<ChangeRolePopupProps> = ({
  currentRole,
  onClose,
  onRequestConfirmation,
}) => {
  const [selectedRole, setSelectedRole] = useState(currentRole);

  // Triggers confirmation request with the selected role
  const handleApply = () => {
    onRequestConfirmation(selectedRole);
  };

  // Updates the selected role when a radio button is clicked
  const handleRoleChange = (role: string) => {
    setSelectedRole(role);
  };

  return (
    <div className='absolute mt-2 bg-white shadow-lg rounded-md p-4 z-50 w-40'>
      <div className='space-y-3'>
        {roles.map((role) => (
          <label
            key={role}
            className='flex items-center gap-2 cursor-pointer text-sm text-[#3F5265]'
          >
            <input
              type='radio'
              name='role'
              value={role}
              checked={selectedRole === role}
              onChange={() => handleRoleChange(role)}
              className='accent-[#00A4BD]'
            />
            {role}
          </label>
        ))}
      </div>
      <button
        onClick={handleApply}
        className='w-full mt-4 py-2 bg-[#00A4BD] text-white rounded-md hover:bg-[#00899E] text-sm font-medium'
      >
        Apply
      </button>
    </div>
  );
};

export default ChangeRolePopup;
